/**
 * ADR-0068: Scope badge pill. Renders "Personal" / "Team: <name>" / "Shared"
 * with variant coloring and an aria-label per spec §8.
 *
 * ADR-0173 §3.4: the Personal tab now includes personal items of people the
 * viewer oversees, so a personal row owned by someone else attributes its
 * owner — "Personal — {owner display name}". Plain "Personal" when the row is
 * the viewer's own, or when the payload carries no owner name (orphaned row).
 * Never a UUID.
 */

import { scopeLabel, type ContentScope } from "../lib/scope.js";

export function ScopePill(props: {
  scope: ContentScope;
  groupName?: string | null;
  /** The row's owner display name (ADR-0173 payloads); shown when not the viewer's own row. */
  ownerDisplayName?: string | null;
  /** True when the row's owner IS the viewer — suppresses the attribution. */
  ownerIsViewer?: boolean;
  className?: string;
}) {
  const base = scopeLabel({ scope: props.scope, owner_group_name: props.groupName ?? null });
  const attributed =
    props.scope === "personal" && props.ownerDisplayName && !props.ownerIsViewer
      ? `Personal — ${props.ownerDisplayName}`
      : base;
  const variantClass =
    props.scope === "personal"
      ? "scopePillPersonal"
      : props.scope === "team"
      ? "scopePillTeam"
      : "scopePillShared";
  const aria =
    props.scope === "team" && props.groupName
      ? `Team scope: ${props.groupName}`
      : `${attributed} scope`;
  return (
    <span
      className={`scopePill ${variantClass}${props.className ? ` ${props.className}` : ""}`}
      aria-label={aria}
    >
      {attributed}
    </span>
  );
}
